// import VueCookie from 'vue-cookie'
import Cookies from 'js-cookie'
export default {
  getShop () {
    let cookieData = {}
    if (process.server) {
      const nuxtApp = useNuxtApp()
      if (nuxtApp && nuxtApp.ssrContext && nuxtApp.ssrContext.event && nuxtApp.ssrContext.event.req) {
        const req = nuxtApp.ssrContext.event.req
        cookieData = this.getInServer(req)
        
        // 服务器端根据域名判断
        const host = req.headers.host
        const protocol = req.headers['x-forwarded-proto'] || (req.connection.encrypted ? 'https' : 'http')
        const origin = `${protocol}://${host}`
        
        // 根据域名设置特定的 shopIcon
        if (host === 'xwyh.shanxiyixue.com') {
          cookieData.shopIcon = `${origin}/_nuxt/assets/logo/xwyh.png`
          cookieData.shopName = '希望易学'
        }
      }
    } else {
      cookieData = {
        shopIcon: location.origin.indexOf('xwyh.shanxiyixue.com')>-1?`${location.origin}/_nuxt/assets/logo/xwyh.png`:this.getInClient('shopIcon'),
        shopName: location.origin.indexOf('xwyh.shanxiyixue.com')>-1?'希望易学':this.getInClient('shopName')
      }
    }
    return cookieData
  },
  // 获取服务端cookie
  getInServer (req) {
    const serviceCookie = {}
    req && req.headers.cookie && req.headers.cookie.split(';').forEach(function (val) {
      const parts = val.split('=')
      serviceCookie[parts[0].trim()] = decodeURIComponent((parts[1] || '').trim())
    })
    return serviceCookie
  },

  setInServer (Cookie, req) {
    if (Cookie.constructor == Object) {
      let cssStr = ''
      for (const key in Cookie) {
        cssStr += key + '=' + Cookie[key] + ';'
      }
      req.headers.cookie = cssStr.slice(0, cssStr.length - 1)
      return cssStr.slice(0, cssStr.length - 1)
    }
  },
  // 获取客户端cookie
  getInClient (key) {
    const tokenInfo = Cookies.get(key)
    return tokenInfo
  },
  // 获取客户端cookie
  setInClient ({ key, val, expires = 1 }) {
    const hostname = window.location.hostname
    const option = {
      expires
    }
    if (hostname !== 'localhost') {
      option.domain = hostname
    }
    if (hostname === '127.0.0.1') {
      delete option.domain
    }
    Cookies.set(key, val, option)
  },
  // 删除客户端cookie
  delInClient (key) {
    const hostname = window.location.hostname
    const option = {
      expires: 1
    }
    if (hostname !== 'localhost') {
      option.domain = hostname
    }
    if (hostname === '127.0.0.1') {
      delete option.domain
    }
    Cookies.remove(key, option)
  }
}
